import { render, staticRenderFns } from "./newsEditor.pug?vue&type=template&id=7cac9ab7&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./newsEditor.scss?vue&type=style&index=0&id=7cac9ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cac9ab7",
  null
  
)

export default component.exports